module.exports = __webpack_public_path__ + "static/media/background2.3bb8bbbd.png";